<template>
  <InputText
    unstyled
    :pt="theme"
    :pt-options="{
      mergeProps: ptViewMerge,
    }"
  />
</template>

<script setup lang="ts">
import InputText, {
  type InputTextPassThroughOptions,
  type InputTextProps,
} from "primevue/inputtext";
import { ref } from "vue";
import { ptViewMerge } from "./utils";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Props extends /* @vue-ignore */ InputTextProps {}
defineProps<Props>();

const theme = ref<InputTextPassThroughOptions>({
  root: `w-full border! appearance-none rounded-xl outline-hidden
        ma-neutral-card ma-inner-shadow
        text-surface-700 dark:text-surface-0
        placeholder:text-surface-400 dark:placeholder:text-surface-500 placeholder:font-medium
        enabled:hover:border-surface-100 dark:enabled:hover:border-surface-700
        enabled:focus:border-surface-100 dark:enabled:focus:border-surface-600/50
        disabled:opacity-60
        p-invalid:border-red-100 dark:p-invalid:border-red-100
        p-invalid:placeholder:text-red-600 dark:p-invalid:placeholder:text-red-400
        px-3 py-2 p-fluid:w-full
        p-small:text-sm p-small:px-[0.625rem] p-small:py-[0.375rem]
        p-large:text-lg p-large:px-[0.875rem] p-large:py-[0.625rem]
        transition-colors duration-200`,
});
</script>
